import apiClient from '../client';
import { ApiResponse, PracticalScore } from '@/types';

interface UpsertPracticalScoreDto {
  score: number;
  durationSeconds?: number | null;
  startTime?: string | null;
  endTime?: string | null;
}

export const practicalScoresApi = {
  getAll: async (): Promise<PracticalScore[]> => {
    const response = await apiClient.get<ApiResponse<PracticalScore[]>>('/practical-scores');
    return response.data.data ?? [];
  },

  upsert: async (studentId: string, dto: UpsertPracticalScoreDto): Promise<PracticalScore> => {
    const response = await apiClient.put<ApiResponse<PracticalScore>>(
      `/practical-scores/${studentId}`,
      dto,
    );
    return response.data.data!;
  },

  remove: async (studentId: string): Promise<void> => {
    await apiClient.delete(`/practical-scores/${studentId}`);
  },
};
